import { render, staticRenderFns } from "./anniv_commande.vue?vue&type=template&id=2003150c&scoped=true&"
import script from "./anniv_commande.vue?vue&type=script&lang=js&"
export * from "./anniv_commande.vue?vue&type=script&lang=js&"
import style0 from "./anniv_commande.vue?vue&type=style&index=0&id=2003150c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003150c",
  null
  
)

export default component.exports